<template>
  <div id="finance-manage" class="app-main-content">
    <div v-show="showMainList" class="grid-view">
      <div class="main-content">
        <search-item
          ref="searchItem"
          :is-simple-query.sync="isSimpleQuery"
          :auto-init="false"
          :show-more-scheme="true"
          :show-simple="true"
          :expand-adv="true"
          reset
          :custom-search-items="customSearchItems"
          :search-item-code="$t('CargoMsg.Cargo_FinancialAudit')"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          config-module="1500"
          @query="queryHandler"
          @advToggle="scrollCallback"
        >
          <template slot="operations">
            <closing-account-btn-group source-view="manageList" :job="job" :hp="closingAccountHp" />
          </template>
        </search-item>
        <div class="section grid-wrapper" style="min-height:350px">
          <cargo-ag-grid
            config-module="180301"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :check-main-record="false"
            :deselect-main-record="false"
            :column-defs="columnDefs"
            :row-data="rowData"
            :show-selected-color="false"
            style="width: 100%;"
            @girdReady="onGridReady"
          />
        </div>
        <div id="footer-wrapper" class="pagination-wrapper">
          <div :class="[shouldFixed?'fixedBottom':'']" class="total-wrapper">
            <charge-currency-total-group
              v-if="reCalc"
              :key="1"
              :amount-to-currency="localCurrency"
              mode="simple"
              data-field="incomeClosingAccount"
              type="both"
              :data-provider="closingAccountHp.dataProvider"
              currency-field="currency"
              :amount-to-currency-label="$t('queryJob.totalIncomeClosingAccount')"
            />
            <charge-currency-total-group
              v-if="reCalc"
              :key="2"
              :amount-to-currency="localCurrency"
              mode="simple"
              data-field="costClosingAccount"
              type="both"
              :data-provider="closingAccountHp.dataProvider"
              currency-field="currency"
              :amount-to-currency-label="$t('queryJob.totalCostClosingAccount')"
            />
            <charge-currency-total-group
              v-if="reCalc"
              :key="3"
              :amount-to-currency="localCurrency"
              mode="simple"
              data-field="realProfitClosingAccount"
              type="both"
              :data-provider="closingAccountHp.dataProvider"
              currency-field="currency"
              :amount-to-currency-label="$t('queryJob.profitClosingAccount')"
            />
            <charge-currency-total-group
              v-if="reCalc"
              :key="4"
              :amount-to-currency="localCurrency"
              mode="simple"
              data-field="income"
              type="both"
              :data-provider="closingAccountHp.totalProfits"
              currency-field="currency"
              :amount-to-currency-label="$t('CargoMsg.Cargo_Receivable')"
            />
            <charge-currency-total-group
              v-if="reCalc"
              :key="5"
              :amount-to-currency="localCurrency"
              mode="simple"
              data-field="cost"
              type="both"
              :data-provider="closingAccountHp.totalProfits"
              currency-field="currency"
              :amount-to-currency-label="$t('CargoMsg.Cargo_Dues')"
            />
            <charge-currency-total-group
              v-if="reCalc"
              :key="6"
              :amount-to-currency="localCurrency"
              mode="simple"
              data-field="realProfit"
              type="both"
              :data-provider="closingAccountHp.totalProfits"
              currency-field="currency"
              :amount-to-currency-label="$t('CargoMsg.Cargo_Profit')"
            />
          </div>
          <cargo-pagination
            config-module="1500001"
            :total="searchConditions.total"
            :page-count="searchConditions.pageCount"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="queryPageHandler"
          />
        </div>
      </div>
    </div>
    <!--详情-->
    <closing-account-detail v-show="showDetail" ref="closingAccountDetail" :view-source="detailViewSource" @backList="toBackList" @exportAll2Excel="exportAll2Excel" />
    <!--业务提成-->
    <c-a-business-commission v-show="showBusinessCommission" ref="businessCommission" :visible.sync="showBusinessCommission" @viewDetail="showDetail4BusinessCommission" @backList="showBusinessCommission=false" />
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
  </div>
</template>

<script>

import URL from '@/api/urlTranslator'
import lodash from 'lodash'
import { DocumentManage, stopBubble } from '@/utils/commonUtil'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import moment from 'moment'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoDropdownMenu from '@/components/Cargo/Common/CargoDropdownMenu'
import cABusinessCommission from './components/ClosingAccount/cABusinessCommission'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import cACheckDialog from './components/ClosingAccount/cACheckDialog'
import changeDialog from './components/financeManage/changeDialog'
import provisionedDialog from './components/financeManage/changeDialog'
import cancelProvisionedDialog from './components/financeManage/changeDialog'
import businessDateDialog from './components/financeManage/changeDialog'
import cALockOrderDialog from './components/ClosingAccount/cALockOrderDialog'
import closingAccountBtnGroup from '@/views/cargo/v0/Clearing/components/ClosingAccount/cABtnGroup'
import ClosingAccountHp from '@/views/cargo/v0/Clearing/components/ClosingAccount/closingAccountHp'
import closingAccountDetail from '@/views/cargo/v0/Clearing/components/ClosingAccount/cADetail'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { LOG_CARRY_FORWARD } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'ClosingAccount',
  components: { ChargeCurrencyTotalGroup, ChargeCountGroup, cargoAdvanceSelect,
    closingAccountBtnGroup, cACheckDialog, cancelProvisionedDialog, changeDialog, provisionedDialog, businessDateDialog, cALockOrderDialog, searchItem, closingAccountDetail, cABusinessCommission, cargoDropdownMenu, cargoTemplateSelectorDialog },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      routeJobNo: '',
      selectedJob: {},
      customConditions: [],
      jobStates: [], // 业务状态
      isAr: -1, //  是否应收
      hasBillPayment: -1, // 是否有付款申请
      showTotalProfit: true, // 显示总利润 (全量数据)
      showCostColumn: true, // 是否显示总成本
      showRevenueColumn: true, // 是否显示总收入
      showVoucherDate: false, // 显示生成凭证日期
      hasCheckRole: true, // 是否根据权限查询数据
      allJobByRole: false, // 查看所有业务
      searchExportExcel: false, // 全部数据，用于导出
      departmentJobByRole: false, // 查看同组业务
      userJobByRole: false, // 查看自己业务
      departmentTeamUser: [], // 同部门的人

      job: {},
      customSearchItems: [], // 自定义高级查询项
      closingAccountHp: new ClosingAccountHp(this),
      loading: false,
      isSimpleQuery: false,
      showCheckDialog: false,
      showChangeDialog: false,
      showLockOrderDialog: false,
      showProvisionedDialog: false,
      showCancelProvisionedDialog: false,
      showBusinessDateDialog: false,

      showControlledProfit: false,

      url: URL,
      showDetail: false,
      showBusinessCommission: false,
      documentManage: new DocumentManage(),
      detailViewSource: '', // detailView详情页的来源
      currentChooseRow: {},
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'JOBLIST',
        data: {
          JOB_UUID: [],
          LOB: 'SE'
        }
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      searchConditions: {
        total: 0, // total传递到后端无用
        pageCount: 0, // pageCount传递到后端无用
        pageNum: 1,
        pageSize: 50,
        simpleTriggerMode: false, // 是否为简单查询触发模式
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        requires: []
      },
      gridOptions: {
        onRowDoubleClicked: this.showDetailView4Manage
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [{ headerName: this.$t('queryJob.businessNumber'), field: 'jobNo', width: 180 }],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      simpleTriggerMode: false, // 记录上一次的查询条件，导出全部使用
      beforeConditions: null, // 记录上一次的查询条件，导出全部使用
      shouldFixed: false,
      showSelectionCount: true,
      selectionCountLabel: '',
      location: LOG_CARRY_FORWARD.code
    }
  },
  computed: {
    showMainList() {
      console.log('!this.showDetail && !this.showBusinessCommission', !this.showDetail && !this.showBusinessCommission, (!this.showDetail) && !this.showBusinessCommission)
      return !this.showDetail && !this.showBusinessCommission
    }
  },
  watch: {
    rowData(newVal) {
      if ((!newVal || newVal.length === 0) && this.routeJobNo) {
        this.$message.error(this.$t('Clearing.YouPermissionToViewData'))
      }
    }
  },
  async created() {
    const { query } = this.$route
    if (query.jobNo && !this.showDetail) {
      this.routeJobNo = query.jobNo
      this.queryHandler({ simpleTriggerMode: true, conditions: this.routeJobNo })
      this.showMainList = false
      this.showDetail = true
      await this.closingAccountHp.created()
      await this.closingAccountHp.initializeHandler()
    } else {
      this.closingAccountHp.created()
      this.closingAccountHp.initializeHandler()
    }
    this.setLocalCurrency()
  },
  beforeMount() {
    this.closingAccountHp.beforeMount()
  },
  mounted() {
    this.getSearchField()
    this.scrollCallback()
    document.querySelector('.app-main-content').addEventListener('scroll', this.scrollCallback)
  },
  activated() {
    if (this.$route.params.activeTabName) {
      this.$refs.closingAccountDetail.activeTabName = this.$route.params.activeTabName
    }
    this.routeJobDetails()
    delete this.$route.params.activeTabName
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  destroyed() {
    document.querySelector('.app-main-content').removeEventListener('scroll', this.scrollCallback, false)
  },
  methods: {
    // 财务审核页筛选值变化事件
    filterChange() {
      this.$nextTick(() => {
        const hasDisplay = []
        this.gridOptions.api.forEachNode(node => {
          if (node.displayed) {
            hasDisplay.push(node.data)
          }
        })
        if (hasDisplay.length > 0) {
          if (hasDisplay.length === this.rowData.length) {
            this.showTotalProfit = true
          }
          if (hasDisplay.length < this.rowData.length) {
            this.showTotalProfit = false
          }
        } else {
          this.showTotalProfit = false
        }
        this.closingAccountHp.refreshSelectedCount()
      })
    },
    onGridReady(params) {

    },
    routeJobDetails() {
      const { query } = this.$route
      if (query.jobNo && !this.showDetail) {
        this.routeJobNo = query.jobNo
        this.queryHandler({ simpleTriggerMode: true, conditions: this.routeJobNo })
      }
    },
    getSearchField() {
      // 业务日期
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'date'
      searchField.itemCondition = []
      searchField.defaultConditionVal = 'RANGE'
      searchField.fieldType = 'FIELD_DATE_RANGE'
      searchField.itemName = 'job.business_date'
      searchField.itemLabel = 'queryJob.businessDate'
      const startDate = moment().subtract(1, 'months').format('YYYY-MM-DD') // 当前时间的前一个月时间
      searchField.itemValue = [startDate]
      searchField.subType = 'range'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = []
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())
    },
    // 分页触发查询
    queryPageHandler() {
      this.searchExportExcel = false
      this.closingAccountHp.doSearchWithProfitAndList()
    },
    // 导出全部
    exportAll2Excel(type) {
      this.closingAccountHp.exportExcelAllClickHandler(type)
    },
    // 查询触发
    queryHandler({ simpleTriggerMode, conditions }) {
      this.searchExportExcel = false
      this.simpleTriggerMode = simpleTriggerMode// 简单查询导出全部
      this.beforeConditions = conditions// 简单查询导出全部
      this.search2({ simpleTriggerMode, conditions })
    },
    search2({ simpleTriggerMode, conditions }) {
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      this.searchConditions.simpleTriggerMode = simpleTriggerMode
      if (this.searchConditions.simpleTriggerMode) {
        if (!conditions) {
          this.$message.warning(this.$t('FinanceManage.finance_inputBusinessNumber'))
          return
        }

        if (this.routeJobNo) { // 跳转查询直接根据jobNo精确查询
          const option = new AdvancedSearchOption(null, 'job.job_no', conditions.trim(), OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        } else {
          // 简单查询，则 combiConditions为string
          const option = new AdvancedSearchOption(null, 'job.job_no', conditions.trim(), OperatorConstants.OPERATOR_LIKE.code)
          finallyConditions.push(option.formatObj2Json())
        }
      } else {
        // 高级查询条件组装
        const advConditions = conditions ? lodash.cloneDeep(conditions) : []
        if (AdvancedSearchOption.hasField('charge.offset_state', advConditions)) {
          const option = AdvancedSearchOption.getOption('charge.offset_state', advConditions)
          if (option.value === false) {
            option.value = ChargeConstants.OFFSET_STATE_NORMAL.code
          } else {
            option.operator = OperatorConstants.OPERATOR_IN.code
            option.value = `${ChargeConstants.OFFSET_STATE_HEDGE.code}, ${ChargeConstants.OFFSET_STATE_BE_HEDGE.code}`
          }
          // 更新某一項
          AdvancedSearchOption.updateOption(option, advConditions)
        }
        if (AdvancedSearchOption.hasField('job.job_state', advConditions)) {
          const option = AdvancedSearchOption.getOption('job.job_state', advConditions)
          if (option.operator === OperatorConstants.OPERATOR_NOT_IN.code) {
            const optionList = option.value
            optionList.push(-1)
            optionList.push(12)
            option.value = optionList
            // 更新某一項
            AdvancedSearchOption.updateOption(option, advConditions)
          }
        }
        finallyConditions.push(...advConditions)
      }
      this.toSupplementConditionsBeforeQuery(finallyConditions)
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      // 查询列表+利润
      this.closingAccountHp.doSearchWithProfitAndList()
    },
    // 查询请求前补充条件
    toSupplementConditionsBeforeQuery(finallyConditions) {
      if (this.customConditions && this.customConditions.length > 0) { finallyConditions.push(...this.customConditions) }

      if (this.jobStates && this.jobStates.length > 0 && !LoadDefaultQueryParam.isSelectOption(finallyConditions, 'job.job_state')) {
        const option = new AdvancedSearchOption(null, 'job.job_state', LoadDefaultQueryParam.convertCommonStateToInt(this.job_states), AdvancedSearchConsts.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      } else if (!AdvancedSearchOption.hasField('job.job_state', finallyConditions)) {
        const option = new AdvancedSearchOption(null, 'job.job_state', LoadDefaultQueryParam.convertCommonStateToInt(SystemConstants.JOB_STATES), AdvancedSearchConsts.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }

      if (this.hasBillPayment !== -1) {
        finallyConditions.push(new AdvancedSearchOption(null, 'charge.bill_payment_uuid', null, this.hasBillPayment === 0 ? AdvancedSearchConsts.OPERATOR_IS_NULL.code : AdvancedSearchConsts.OPERATOR_IS_NOT_NULL.code).formatObj2Json())
      }
      if (this.isAr !== -1) { finallyConditions.push(new AdvancedSearchOption(null, 'charge.receivable', Number(this.isAr) === 1).formatObj2Json()) }

      const requires = []
      if (this.showRevenueColumn || this.showCostColumn) { requires.push('revenue') }
      if (this.showVoucherDate) { requires.push('voucherDate') }
      if (this.showTotalProfit) { requires.push('showTotalProfit') }
      // 待结转
      requires.push('closingAccount')
      this.searchConditions.requires = requires
    },
    // 业务编号旁的搜索按钮事件
    showTemplateDialog(e) {
      stopBubble(e)
      if (!this.selectedJob) return
      this.templateSelectorDialog.cxt = this.selectedJob
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedJob.uuid }
      this.templateSelectorDialog.visible = true
    },
    async showDetailView4Manage({ data } = {}, needChecked = false) {
      this.closingAccountHp.showDetailView(needChecked, { ...data }, this.gridOptions, this.rowData)
    },
    toBackList(toView) {
      this.showDetail = false
      this.queryPageHandler()
      if (toView === 'manageList') {
        this.showBusinessCommission = false
      } else {
        this.showBusinessCommission = true
      }
    },
    showDetail4BusinessCommission({ detailData, treeDataArr, fromView }) {
      this.detailViewSource = fromView
      this.showDetail = true
      this.$nextTick(() => {
        this.$refs.closingAccountDetail.showDetail(detailData, treeDataArr)
      })
    },
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.app-main-content')
        const footer = document.getElementById('footer-wrapper')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        console.log('containerHeight', containerHeight)
        console.log('offset', offset)
        if (offset > containerHeight + 50) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>

<style lang="scss">
#footer-wrapper {
  align-items: center;
  .fixedBottom {
    position: fixed;
    bottom: 0;
    right: 15px;
    background: #fff;
  }
}
</style>
